import { motion } from "framer-motion";

const fmtRange = (s, e) => {
  const a = new Date(s + "T00:00:00");
  const b = new Date(e + "T00:00:00");
  const sameMonth = a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
  const day = (d) => d.toLocaleDateString("en-IN", { day: "numeric" });
  const month = (d) => d.toLocaleDateString("en-IN", { month: "short" });
  const year = (d) => d.getFullYear();
  if (sameMonth) {
    return `${day(a)}—${day(b)} ${month(a)} ${year(a)}`;
  }
  return `${day(a)} ${month(a)} — ${day(b)} ${month(b)} ${year(b)}`;
};

export default function UpcomingBookings({ bookings, currentName, onCancel, onConfirm, onNudge }) {
  return (
    <section
      className="bg-white border border-[#DCE0D9] p-7"
      data-testid="upcoming-card"
    >
      <div className="flex items-center justify-between">
        <p className="tracker text-[10px] text-[#5C6B61]">Upcoming</p>
        <span className="font-body text-xs text-[#1A2F24]">
          {bookings.length}
        </span>
      </div>
      <h2 className="font-display text-3xl text-[#1A2F24] mt-1">
        At the house
      </h2>

      {bookings.length === 0 ? (
        <p
          className="font-body text-sm text-[#5C6B61] mt-6"
          data-testid="upcoming-empty"
        >
          No one&apos;s up there yet. The hills are quiet — be the first to claim a weekend.
        </p>
      ) : (
        <ul className="mt-6 divide-y divide-[#DCE0D9] border-t border-[#DCE0D9]">
          {bookings.map((b, i) => (
            <motion.li
              key={b.id}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * i }}
              className="py-4 flex items-start gap-4"
              data-testid={`booking-row-${b.id}`}
            >
              <span
                className="mt-2 inline-block h-2 w-6 shrink-0"
                style={{ background: b.color || "#1A2F24" }}
              />
              <div className="flex-1 min-w-0">
                <p className="font-display text-xl text-[#1A2F24] leading-tight flex items-center gap-2 flex-wrap">
                  {b.member_name}
                  {b.block_type === "soft" ? (
                    <span
                      data-testid={`badge-soft-${b.id}`}
                      className="tracker text-[9px] text-[#9E473F] border border-[#9E473F]/50 px-2 py-0.5"
                    >
                      Tentative
                    </span>
                  ) : (
                    <span
                      data-testid={`badge-hard-${b.id}`}
                      className="tracker text-[9px] text-[#5C6B61] border border-[#DCE0D9] px-2 py-0.5"
                    >
                      Confirmed
                    </span>
                  )}
                </p>
                <p className="font-body text-sm text-[#5C6B61] mt-1">
                  {fmtRange(b.start_date, b.end_date)}
                </p>
                {b.note && (
                  <p className="font-display italic text-base text-[#1A2F24]/80 mt-2">
                    “{b.note}”
                  </p>
                )}
              </div>
              <div className="flex flex-col items-end gap-2 shrink-0">
                {b.member_name === currentName ? (
                  <>
                    {b.block_type === "soft" && (
                      <button
                        onClick={() => onConfirm(b.id)}
                        data-testid={`confirm-${b.id}`}
                        className="font-body text-[10px] tracker text-[#1A2F24] border border-[#1A2F24] px-2 py-1 hover:bg-[#1A2F24] hover:text-[#FAF9F6] transition-colors duration-300"
                      >
                        Confirm
                      </button>
                    )}
                    <button
                      onClick={() => onCancel(b.id)}
                      data-testid={`cancel-${b.id}`}
                      className="font-body text-[10px] tracker text-[#9E473F] hover:text-[#1A2F24] transition-colors duration-300"
                    >
                      {b.block_type === "soft" ? "Release" : "Cancel"}
                    </button>
                  </>
                ) : (
                  b.block_type === "soft" && (
                    <button
                      onClick={() => onNudge(b.id)}
                      data-testid={`nudge-${b.id}`}
                      className="font-body text-[10px] tracker text-[#5C6B61] hover:text-[#9E473F] transition-colors duration-300"
                    >
                      Still going?
                    </button>
                  )
                )}
              </div>
            </motion.li>
          ))}
        </ul>
      )}
    </section>
  );
}
